import React from 'react';

const PARAS = [
    'More information means better decisions. Better decisions create value.',
    'AI now lets us deliver fast, affordable diligence — corporate, legal, financial, technical — all on one platform, at a cost that was unthinkable even two years ago.',
    "But here's what we've learned: investors and buyers using our tools uncover ten times more red flags. That means slower deals and price chipping.",
    'The answer? Get investor-ready before the transaction starts. Use those same tools to self-diligence, fix the gaps, and present a clean house from day one. The result: quicker deals, lower costs, higher valuations — and far less chance of a deal falling apart. Then connect directly to investors through the platform.',
    "Curious? Try it for free or book a call — I'd love to hear from you.",
];

const HomeFounderNote = () => (
    <section className="lp-founder">
        <div className="lp-founder-inner">
            <div className="lp-founder-copy">
                <h2 data-lp-reveal>A note from our founder</h2>
                {PARAS.map((p, i) => <p key={i} data-lp-reveal data-lp-delay={60 + i * 40}>{p}</p>)}
                <p className="nm" data-lp-reveal data-lp-delay="260">Mark Bernstein ACA, CEO</p>
                <img className="sig" src={require('../../../../images/landing-pages/home-page/mark-signature.png')} alt="Mark Bernstein signature" data-lp-reveal data-lp-delay="300" />
            </div>
            <div className="lp-founder-media" data-lp-reveal data-lp-delay="140">
                <img src={require('../../../../images/landing-pages/home-page/mark-photo.png')} alt="Mark Bernstein, CEO" />
            </div>
        </div>
    </section>
);

export default HomeFounderNote;
